export const SENSOR_REQUEST = 'SENSOR_REQUEST'
export const SENSOR_SUCCESS = 'SENSOR_SUCCESS'
export const SENSOR_ERROR = 'SENSOR_ERROR'
export const SENSOR_SELECT = 'SENSOR_SELECT'



